import { render, staticRenderFns } from "./OnboardingChecklist.vue?vue&type=template&id=28bb0109"
import script from "./OnboardingChecklist.js?vue&type=script&lang=js&external"
export * from "./OnboardingChecklist.js?vue&type=script&lang=js&external"
import style0 from "./OnboardingChecklist.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports